/**
 * Alias de nombres de deporte (workaround de datos sucios).
 *
 * Los eventos se guardan/consultan por el nombre de deporte canónico en INGLÉS y en minúsculas
 * (p.ej. "obstacles"). Un subconjunto de eventos se guardó con una grafía no canónica (normalmente
 * en español, p.ej. "obstaculos"), lo que rompe tanto la consulta de eventos como los enlaces
 * /sport/{slug} generados a partir de `data.sport`.
 *
 * DEBE mantenerse en sincronía con:
 *  - Backend `SportNameAliases` en RegistrationController (BKD-Public-NET8).
 *  - La capa de consulta del FE (services/events.ts usa este mismo mapa).
 *
 * Clave = nombre canónico en inglés (minúsculas). Valor = grafías alternativas almacenadas en BD.
 */
export const SPORT_NAME_ALIASES: Record<string, string[]> = {
  obstacles: ['obstaculos'],
  other: ['Otros'],
  running: ['Running/Atletismo', 'running/athletics'],
};

// Lookup inverso: grafía almacenada (en minúsculas) → nombre canónico en inglés.
const REVERSE_ALIAS: Record<string, string> = Object.entries(SPORT_NAME_ALIASES).reduce(
  (acc, [canonical, aliases]) => {
    for (const alias of aliases) acc[alias.toLowerCase()] = canonical;
    return acc;
  },
  {} as Record<string, string>
);

/**
 * Normaliza un valor de `data.sport` (posiblemente sucio, p.ej. "obstaculos") a su nombre canónico
 * en inglés (p.ej. "obstacles") para construir slugs/URLs de /sport que la página sepa resolver.
 * Si el valor ya es canónico (o desconocido), se devuelve tal cual.
 */
export function canonicalSportName(value: string | undefined | null): string {
  if (!value) return '';
  return REVERSE_ALIAS[value.toLowerCase()] ?? value;
}
